var map = {
	"./Book": 5,
	"./Book.svg": 5,
	"./Book2": 6,
	"./Book2.svg": 6,
	"./CameraVideoFill": 7,
	"./CameraVideoFill.svg": 7,
	"./CheckSquareFil-black": 8,
	"./CheckSquareFil-black.svg": 8,
	"./CheckSquareFil-info": 9,
	"./CheckSquareFil-info.svg": 9,
	"./CheckSquareFill-primary": 10,
	"./CheckSquareFill-primary.svg": 10,
	"./CheckSquareFill-secondary": 11,
	"./CheckSquareFill-secondary.svg": 11,
	"./DonwloadRedacao": 12,
	"./DonwloadRedacao.svg": 12,
	"./FileTextFill": 13,
	"./FileTextFill.svg": 13,
	"./GraphUp": 14,
	"./GraphUp.svg": 14,
	"./LockFill": 15,
	"./LockFill.svg": 15,
	"./VolumeUpFill": 16,
	"./VolumeUpFill.svg": 16,
	"./anos_finais": 17,
	"./anos_finais.svg": 17,
	"./anos_iniciais": 18,
	"./anos_iniciais.svg": 18,
	"./arrow-left": 19,
	"./arrow-left.svg": 19,
	"./arrow-right": 20,
	"./arrow-right-circle": 21,
	"./arrow-right-circle.svg": 21,
	"./arrow-right.svg": 20,
	"./arrow-select": 22,
	"./arrow-select.svg": 22,
	"./back": 23,
	"./back.svg": 23,
	"./camera": 24,
	"./camera.svg": 24,
	"./ckeck": 25,
	"./ckeck.svg": 25,
	"./coroa-finish": 26,
	"./coroa-finish.svg": 26,
	"./exclamation": 27,
	"./exclamation.svg": 27,
	"./infantil": 28,
	"./infantil.svg": 28,
	"./linguagens-sign": 29,
	"./linguagens-sign.svg": 29,
	"./link-ia": 30,
	"./link-ia.svg": 30,
	"./logo": 31,
	"./logo-maxia": 32,
	"./logo-maxia-symbol": 33,
	"./logo-maxia-symbol.svg": 33,
	"./logo-maxia.svg": 32,
	"./logo-topo-fixo": 34,
	"./logo-topo-fixo.svg": 34,
	"./logo.svg": 31,
	"./logo_02": 35,
	"./logo_02.svg": 35,
	"./logotipo-maxia": 36,
	"./logotipo-maxia.svg": 36,
	"./medio": 37,
	"./medio-blocked": 38,
	"./medio-blocked.svg": 38,
	"./medio.svg": 37,
	"./mini-check": 39,
	"./mini-check.svg": 39,
	"./nav-volta-azul": 40,
	"./nav-volta-azul.svg": 40,
	"./nav-voltar": 41,
	"./nav-voltar.svg": 41,
	"./next": 42,
	"./next.svg": 42,
	"./patch-question": 43,
	"./patch-question-fill": 44,
	"./patch-question-fill.svg": 44,
	"./patch-question.svg": 43,
	"./poposta": 45,
	"./poposta.svg": 45,
	"./turno-manha": 46,
	"./turno-manha.svg": 46,
	"./turno-tarde": 47,
	"./turno-tarde.svg": 47
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1683;